import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import search from "./search";
import map from "./map";

export default combineReducers({
  routing: routerReducer,
  search,
  map
});



// WEBPACK FOOTER //
// ./src/modules/index.js